var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-3/4"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/HeffronLogo_RGB.svg"),"alt":"Heffron","width":"w-full"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }